/* ------------------- IMPORTS */
import styled from '@emotion/styled'
import { Box } from 'components/Box'
import { AppStore } from 'utils'

/* ------------------- TYPES  */

/* ------------------- INTERFACES  */
interface Props {
  message?: string
}

export default function ErrorMessage({ message }: Props) {
  /* ----------------- TRANSLATIONS  */

  /* ----------------- STATE  */

  /* ----------------- ROUTER  */

  /* ----------------- ENUM  */

  /* ----------------- REF  */

  /* ----------------- ZUSTAND  */

  /* ----------------- VARIABLES  */

  /* ----------------- METHODS  */
  const getErrorMessage = () => {
    if (!message) return 'No error message provided'

    try {
      // Get the message from the error object
      const messageObject = JSON.parse(message)
      console.log('Parsed message:', messageObject)

      // If the message is in the new format: messageObject.error
      if (messageObject?.error) {
        try {
          const errorObject = JSON.parse(messageObject.error)
          if (errorObject?.message) return errorObject.message
        } catch {
          if (typeof messageObject.error === 'string') return messageObject.error
        }
      }

      // Another error Format -> gestisce messageObject.res.error.message
      if (messageObject?.res?.error?.message) return messageObject.res.error.message

      // Another error Format -> check the message itself
      if (messageObject?.message) return messageObject.message

      // If the previouse checks fail, return a default error message
      return 'Unknown error'
    } catch (error) {
      // Il messaggio non è JSON valido, prova a usarlo direttamente
      console.error('Error parsing message:', error)
      return typeof message === 'string' ? message : 'Invalid error format'
    }
  }

  /* ----------------- API CALL  */

  /* ----------------- USEEFFECT  */

  /* ----------------- CONFIG  */

  return <ErrorMessageContainer>{getErrorMessage()}</ErrorMessageContainer>
}

const ErrorMessageContainer = styled(Box)`
  position: absolute;
  top: calc(100% + 16px);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  min-height: 40px !important;
  width: 100%;
  padding: 24px 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 14px !important;
  border: 1px solid ${() => AppStore.theme.o.on_error_container};
  background: ${() => AppStore.theme.o.error_container};
  color: ${() => AppStore.theme.o.on_error_container};

  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  &:hover {
    background: ${() => AppStore.theme.o.error_container};
  }
`
